import CheckIcon from './check'
import Close from './close'

export default {
	CheckIcon,
	Close
}